<template lang="pug">
#gift-payment-container
  toolbar(type="black")
  validation-observer(v-slot="{ invalid, validated, handleSubmit }")
    #cont-ent.pt-5
      b-container.pb-0
        b-row
          b-col.mb-5.mb-md-0(md="4")
            
          b-col.text-center(md="4")
            h1.text-center.black.bold.mb-5 Selecciona tu regalo
            p.text-center Tipo de servicio:
            b-dropdown.dd-services(no-caret, menu-class="dd-services", variant="info")
              template(v-slot:button-content)
                .d-flex.align-items-center.justify-content-between
                  span.mr-3 {{ selectedService ? selectedService.name : "Selecciona el servicio"  }}
                  chevron-down-icon.icon-md
              b-dropdown-item(v-for="(service, index) in services", :key="service.category + service.type", @click="selectGift(service)") {{ service.name }}
      b-container.text-center
        p.text-center Duración:
        .time-buttons-container.mb-5
          b-button.p-button-big(:pressed="selectedDuration == time", :variant="selectedDuration == time ? 'info' : 'primary'", size="lg", pill, v-for="time in times", :key="time", @click="selectedDuration = time") {{ time }} minutos
        p.text-center Precio:
        .total_discount(v-if="total != subtotal") ${{subtotal}} MXN
        h1.text-center ${{ total }} MXN
        p.mt-5.text-center *La persona que obtenga este certificado podrá elegir un masaje o facial que se encuentre en nuestro catálogo.
        b-form.mt-5
          b-row
            b-col(v-if="!promocode" md="10", offset-md="1", lg="8", offset-lg="2")
              b-row.mb-3.mb-md-5
                b-col.mb-3.mb-md-0(md="8")
                  b-form-group(label="¿Tienes un código promocional?")
                  b-form-input.form-control-flush(placeholder="Ingresa tu código promocional", v-model="promocodeInput" style="border-radius:0;border-bottom:1px solid #ced4da;")
                  small.text-danger {{promocodeError}}
                b-col.mb-3.mb-md-0(md="4")
                  b-form-group(label="")
                  b-button.p-button(variant="info", pill, @click="validatePromocode") Aplicar código promocional
            b-col.text-center(v-else md="10", offset-md="1", lg="8", offset-lg="2")
              p.promo.mb-0 Promoción aplicada: {{getPromocodeDiscount()}}
              p.promo_options
                span.option(@click="setPromo('delete')") Quitar 
                span  | 
                span.option(@click="setPromo('edit'); promoModal = true")  Editar
      b-container#gift-details
        h2.text-center.black.bold.mb-5 ¿A quién se lo enviaremos?
        b-row
          b-col(md="10", offset-md="1", lg="8", offset-lg="2")
            p.mb-md-5 *Si no quieres que el certificado digital le llegue hoy, escribe tu correo en ambos campos de correo electrónico. Lo recibirás tú y lo podrás mandar cuando quieras.
          b-col(md="10", offset-md="1", lg="8", offset-lg="2")
            b-row.mb-3.mb-md-5
              b-col.mb-3.mb-md-0(md="6")
                validation-provider(rules="required", v-slot="{ valid, errors }", name="nombre")
                  b-form-group(label="De:")
                    b-form-input.form-control-flush(placeholder="Tu nombre", :value="giftForm.fromName", @input="$store.commit('forms/setGiftFormAttr', {attr: 'fromName', value: $event})", style="border-radius:0;border-bottom:1px solid #ced4da;", :state="errors[0] ? false : null")
                    b-form-invalid-feedback {{ errors[0] }}
              b-col(md="6")
                validation-provider(rules="required|email", name="correo", v-slot="{ valid, errors }")
                  b-form-group(label="Tu correo:")
                    b-form-input.form-control-flush(placeholder="Tu correo", :value="giftForm.fromEmail", @input="$store.commit('forms/setGiftFormAttr', {attr: 'fromEmail', value: $event})", style="border-radius:0;border-bottom:1px solid #ced4da;", :state="errors[0] ? false : null")
                    b-form-invalid-feedback {{ errors[0] }}
            b-row.mb-5
              b-col.mb-3.mb-md-0(md="6")
                validation-provider(rules="required", v-slot="{ valid, errors }", name="tu nombre")
                  b-form-group(label="Para:")
                    b-form-input.form-control-flush(placeholder="Su nombre", :value="giftForm.toName", @input="$store.commit('forms/setGiftFormAttr', {attr: 'toName', value: $event})", style="border-radius:0;border-bottom:1px solid #ced4da;", :state="errors[0] ? false : null")
                    b-form-invalid-feedback {{ errors[0] }}
              b-col(md="6")
                validation-provider(rules="required|email", name="su correo", v-slot="{ valid, errors }")
                  b-form-group(label="Correo:")
                    b-form-input.form-control-flush(placeholder="Su correo", :value="giftForm.toEmail", @input="$store.commit('forms/setGiftFormAttr', {attr: 'toEmail', value: $event})", style="border-radius:0;border-bottom:1px solid #ced4da;", :state="errors[0] ? false : null")
                    b-form-invalid-feedback {{ errors[0] }}
            b-row.justify-content-center.mb-5
              b-col(md="12")
                validation-provider(rules="required" name="mensaje", v-slot="{ valid, errors }")
                  b-form-group(label="Mensaje:")
                    b-form-textarea(placeholder="Envíale un mensaje", :value="giftForm.message", @input="$store.commit('forms/setGiftFormAttr', {attr: 'message', value: $event})", rows="5", max-rows="100", no-resize :state="errors[0] ? false : null")
                    b-form-invalid-feedback {{ errors[0] }}

            b-row.mb-3.mb-md-5
              b-col.mb-3.mb-md-0(md="12")
                b-form-group
                  b-form-checkbox-group.text-center(v-model="isDeliveryGroup", :options="checkOptions")
                  p.mt-5(v-if="isDelivery") Selecciona el envoltorio para tu certificado
                  b-dropdown.dd-services.mb-5(v-if="isDelivery" no-caret, menu-class="dd-services", variant="info")
                    template(v-slot:button-content)
                      .d-flex.align-items-center.justify-content-between
                        span.mr-3 {{ giftItem ? `${giftItem.get('name')} $${giftItem.get('price')}` : "Selecciona el envoltorio"  }}
                        chevron-down-icon.icon-md
                    b-dropdown-item(v-for="(item, index) in giftCatalog", :key="item.get('name') + item.get('price')", @click="selectGiftCatalog(item)") {{ `${item.get('name')} $${item.get('price')}` }}
                validation-provider(v-if="isDelivery" :rules="{required: true}", v-slot="{ valid, errors }", name="calle y número exterior")
                  b-form-group(label="Ingresa la dirección de envío, por el momento sólo tenemos cobertura en la Ciudad de México")
                  b-form-input.form-control-flush(placeholder="Calle y número exterior", v-model="deliveryAddress" style="border-radius:0;border-bottom:1px solid #ced4da;" :state="errors[0] ? false : null")
                  b-form-invalid-feedback {{ errors[0] }}
                validation-provider(v-if="isDelivery" :rules="{required: true}", v-slot="{ valid, errors }", name="colonia")
                  b-form-input.form-control-flush(placeholder="Colonia", v-model="suburb" style="border-radius:0;border-bottom:1px solid #ced4da;" :state="errors[0] ? false : null")
                  b-form-invalid-feedback {{ errors[0] }}
                validation-provider(v-if="isDelivery" :rules="{required: true}", v-slot="{ valid, errors }", name="código postal")
                  b-form-input.form-control-flush(placeholder="Código postal", v-model="postalCode" style="border-radius:0;border-bottom:1px solid #ced4da;" :state="errors[0] ? false : null")
                  b-form-invalid-feedback {{ errors[0] }}
                  b-container.pb-0

      #payment-method(style="background:#fbfbfb;")
        b-container
          h2.text-center.black.bold.mb-5 Método de pago
          p.text-center.w-75.w-md-50.mx-auto.mb-5 Se efectuará un cargo a tu método de pago y se te enviará un recibo de pago al correo {{ giftForm.fromEmail }}. Todos los certificados de regalo de SCAPE son NO REEMBOLSABLES.
          b-container
            b-row.mb-4(v-if="user")
              b-col(md="10", offset-md="1", lg="8", offset-lg="2")
                card-item.card-row(v-for="card_, key in cards" :card="card_" :key="key" @click.native="setCard(card_)" :selected="card == card_" :selectable="true")
                .my-3.text-center.pointer.hover-info(@click="cardModal = true", style="width: 100%")
                  plus-circle-icon.mr-2.icon-md
                  span Nuevo método de pago
            b-form(v-if="!user")
              b-row
                b-col(md="10", offset-md="1", lg="8", offset-lg="2")
                  b-row.mb-3.mb-md-5
                    b-col.mb-3.mb-md-0(md="6")
                      validation-provider(:rules="{required: true, regex: /[0-9 ]+/}", v-slot="{ valid, errors }", name="número de tarjeta")
                        b-form-group(label="Número de tarjeta:")
                          b-form-input.form-control-flush(placeholder="No. de tarjeta", v-mask="!isAmex ? '#### #### #### ####' : '#### ###### #####'", :value="cardForm.card", @input="$store.commit('forms/setCardFormAttr', {attr: 'card', value: $event})", style="border-radius:0;border-bottom:1px solid #ced4da;", :state="errors[0] ? false : null")
                          b-form-invalid-feedback {{ errors[0] }}
                    b-col(md="6")
                      validation-provider(rules="required", name="nombre en tarjeta", v-slot="{ valid, errors }")
                        b-form-group(label="Nombre en tarjeta:")
                          b-form-input.form-control-flush(placeholder="Nombre", :value="cardForm.name", @input="$store.commit('forms/setCardFormAttr', {attr: 'name', value: $event})", style="border-radius:0;border-bottom:1px solid #ced4da;", :state="errors[0] ? false : null")
                          b-form-invalid-feedback {{ errors[0] }}
                  b-row.mb-5
                    b-col.mb-3.mb-md-0(md="6")
                      validation-provider(rules="required|numeric|min:3|max:4", v-mask="'####'", name="CVV", v-slot="{ valid, errors }")
                        b-form-group(label="CVV:")
                          b-form-input.form-control-flush(placeholder="CVV", :value="cardForm.cvv", @input="$store.commit('forms/setCardFormAttr', {attr: 'cvv', value: $event})", style="border-radius:0;border-bottom:1px solid #ced4da;", :state="errors[0] ? false : null")
                          b-form-invalid-feedback {{ errors[0] }}
                    b-col(md="6")
                      validation-provider(rules="required", name="vigencia", v-slot="{ valid, errors }")
                        b-form-group(label="Vigencia:")
                          b-form-input.form-control-flush(placeholder="MM / AA", v-mask="'##/##'", :value="cardForm.date", @input="$store.commit('forms/setCardFormAttr', {attr: 'date', value: $event})", style="border-radius:0;border-bottom:1px solid #ced4da;", :state="errors[0] ? false : null")
                          b-form-invalid-feedback {{ errors[0] }}

      #summary
        b-container
          h2.text-center.black.bold.mb-5 Resumen de la orden:
          b-row
            b-col(md="8", offset="2")
              b-row
                b-col.mb-5(md="6")
                  .d-flex.align-items-center.mb-3
                    span.black Regalo:
                  b-link.text-reset(v-scroll-to="{el: '#cont-ent'}")
                    .d-flex.align-items-center
                      edit-2-icon.icon-md.mr-3.black
                      span {{ selectedService ? selectedService.name : '' }}
                b-col.mb-5(md="6")
                  .d-flex.align-items-center.mb-3
                    span.black Duración:
                  b-link.text-reset(v-scroll-to="{el: '#cont-ent'}")
                    .d-flex.align-items-center
                      edit-2-icon.icon-md.mr-3.black
                      span {{ selectedDuration }} minutos
                b-col.mb-5(md="6")
                  .d-flex.align-items-center.mb-3
                    span.black De:
                  b-link.text-reset(v-scroll-to="{el: '#gift-details'}")
                    .d-flex.align-items-center
                      edit-2-icon.icon-md.mr-3.black
                      span {{giftForm.fromName}} ({{giftForm.fromEmail}})
                b-col.mb-5(md="6")
                  .d-flex.align-items-center.mb-3
                    span.black Para:
                  b-link.text-reset(v-scroll-to="{el: '#gift-details'}")
                    .d-flex.align-items-center
                      edit-2-icon.icon-md.mr-3.black
                      span {{giftForm.toName}} ({{giftForm.toEmail}})
                b-col.mb-5(md="6")
                  .d-flex.align-items-center.mb-3
                    span.black Método de pago:
                  b-link.text-reset(v-scroll-to="{el: '#payment-method', offset: -70}")
                    .d-flex.align-items-center
                      edit-2-icon.icon-md.mr-3.black
                      span(v-if="user") {{ card ? card.lastFour : '' }}
                      span(v-else) {{ cardForm.card ? cardForm.card.split(' ').slice(-1)[0] : 'No especificado' }}
                b-col.mb-5(md="6")
                  .d-flex.align-items-center.mb-3
                    span.black Total:
                  .d-flex.align-items-center
                    edit-2-icon.icon-md.mr-3.black(style="visibility:hidden;")
                    span(v-if="total") ${{total.toFixed(2)}} MXN

          .text-center.mt-5
            b-button.p-button(variant="success", pill, @click="handleSubmit(confirmPayment)" :disabled="isLoading || (user && !card)") Confirmar la compra
            p.text-center.text-sm.text-danger.mt-3(v-if="validated && invalid") Hay campos obligatorios incompletos
            p.text-center.text-sm.text-danger.mt-3(v-if="user && !card") Debes elegir un método de pago
    modal-card-form(:show="cardModal" @dismiss="cardModal = false" @cardCreated="cardCreated")


    b-modal(hide-header, hide-footer, v-model="cardCreatedModal", content-class="special-modal", centered)
      .d-flex.align-items-center.justify-content-center.flex-column.p-3
        h3.text-center.mb-4 Método de pago registrado
        p.text-center.mb-4 Haz registrado un nuevo método de pago
        b-button.p-button(variant="info", pill, @click="cardCreatedModal = false") OK

    b-modal(hide-header, hide-footer, v-model="giftCreated", style="border-radius: 1rem;", centered, @hidden="success")
      .d-flex.align-items-center.justify-content-center.flex-column.p-5
        b-img.mb-5(src="@/assets/plane-icon.png", width="100")
        h1.text-center.mb-4 ¡Regalo enviado!
        p.text-center.mb-4(v-if="!isDelivery") Tu regalo ha sido enviado a #[strong {{giftForm.toName}}] al correo #[strong {{giftForm.toEmail}}], también te hemos enviado un correo de confirmación a #[strong {{giftForm.fromEmail}}].
        p.text-center.mb-4(v-else) ¡Tu certificado de regalo se ha creado con éxito! El certificado físico será enviado en un plazo de 2 a 3 días hábiles, témbien recibirás un correo de confirmación con los detalles de tu compra.
        b-button.p-button(variant="info", pill, @click="giftCreated = false") Entendido

    b-modal(hide-header, hide-footer, v-model="giftError", style="border-radius: 1rem;", centered)
      .d-flex.align-items-center.justify-content-center.flex-column.p-5
        h1.text-center.mb-4 ¡Oh ooh!
        p.text-center.mb-4 Ocurrio un error al procesar tu regalo: {{error}}.
        b-button.p-button(variant="warning", pill, @click="giftError = null") Regresar
</template>

<script>
import Toolbar from "@/components/Toolbar.vue";
import Footer from "@/components/Footer.vue";
import CardItem from "@/components/items/CardItem";
import ModalCardForm from "@/components/forms/ModalCardForm";

import { mapState, mapMutations, mapActions } from "vuex";

export default {
  components: {
    Toolbar,
    CardItem,
    ModalCardForm
  },
  data() {
    return {
      checkOptions: [
        {
          value: true,
          text: "¿Deseas enviar un certificado físico?",
        },
      ],
      promocodeInput: null,
      promocode: null,
      promocodeError: null,
      isDeliveryGroup: [],
      deliveryAddress: null,
      postalCode: null,
      suburb: null,
      services: [],
      times: [],
      giftCatalog: [],
      giftItem: null,
      giftCreated: false,
      giftError: false,
      error: null,
      isLoading: false,
      categorySelected: null,
      selectedService: null,
      selectedDuration: null,
      cardModal: false,
      cardCreatedModal: false,
      card: null,
    };
  },
  computed: {
    ...mapState("forms", [
      "giftForm",
      "cardForm",
      "selectedGift",
      "selectedTime",
    ]),
    ...mapState("context", ["user", "cards", "promocodes"]),
    isDelivery() {
      return this.isDeliveryGroup.filter((x) => x == true).length > 0
    },
    subtotal() {
      if (this.selectedDuration) {
        return this.selectedService.services.find(
          (service) => service.duration == this.selectedDuration
        ).price;
      }
    },
    total() {
      let total = this.subtotal
      if (this.promocode)
        if(this.promocode.discount >= 100) {
          total = total - this.promocode.discount
        } else {
          total = total - (total * this.promocode.discount) / 100
        }
      if (this.isDelivery && this.giftItem) {
        total += this.giftItem.amount
      }
      return total
    },
    isAmex() {
      return this.cardForm.card.startsWith("37");
    },
  },
  methods: {
    ...mapActions("context", ["loadCards", "loadPromos"]),
    ...mapMutations("forms", ["clearGiftForm", "clearCardForm"]),
    selectGift(service) {
      this.times = service.services.map((a) => a.duration)
      this.selectedService = service
      if (!this.selectedDuration) this.selectedDuration = this.times[0]
    },
    selectGiftCatalog(item) {
      this.giftItem = item
    },
    createToken(params) {
      return new Promise((resolve, reject) => {
        this.$conekta.Token.create(
          params,
          (token) => resolve(token.id),
          (error) => reject(error)
        );
      });
    },
    getPromocodeDiscount() {
      if(this.promocode != null) {
        if(this.promocode.discount >= 100) {
          return `$${this.promocode.discount} de Descuento`
        } else {
          return `${this.promocode.discount}% de Descuento`
        }
      }
    },
    validatePromocode() {
      this.promocodeError = null
      let promoExist = this.promocodes.find(
        (promo) => promo.title == this.promocodeInput
      )
      if (promoExist) {
        this.promocode = promoExist;
      } else {
        this.$parse.Cloud.run('validatePromocode', {
          code: this.promocodeInput,
        })
          .then((validation) => {
            let promocode = validation
            if (promocode.discount == 100)
              this.promocodeError =
                'El código que ingresaste es de un certificado de regalo que no es válido para esta compra.'
            else this.promocode = validation
          })
          .catch((error) => {
            console.error(error.message)
            switch (error.message.status) {
              case 'NOT_FOUND':
                this.promocodeError = 'Código promocional no válido'
                break;
              case 'EXPIRED':
                this.promocodeError = 'Código promocional expirado'
                break;
              case 'NOT_AVAILABLE':
                this.promocodeError =
                  'El código promocional ya no está disponible'
                break;
              case 'ALREADY_USED':
                this.promocodeError =
                  'Ya se ha utilizado este código promocional'
                break;
              default:
                this.promocodeError = error.message.status
            }
          })
      }
    },
    confirmPayment() {
      if (this.user) {
        this.createGift()
      } else {
        var tokenParams = {
          card: {
            number: this.cardForm.card,
            name: this.cardForm.name,
            exp_month: this.cardForm.date.split("/")[0],
            exp_year: this.cardForm.date.split("/")[1],
            cvc: this.cardForm.cvv,
          },
        }
        this.isLoading = true
        this.createToken(tokenParams)
          .then((token) => {
            this.createGift(token)
          })
          .catch((error) => {
            if (error.response) {
              this.error = error.response.data.message.details[0].message
            } else {
              this.error = error.message || error
            }
            this.giftError = true
            this.isLoading = false
          })
      }
    },
    createGift(token = null) {
      if (this.giftForm.message.length > 300) {
        this.error = 'El mensaje es demasiado largo'
        this.giftError = true
        this.isLoading = false
        return
      }
      let data = {
        from: {
          name: this.giftForm.fromName,
          email: this.giftForm.fromEmail,
        },
        to: {
          name: this.giftForm.toName,
          email: this.giftForm.toEmail,
        },
        message: this.giftForm.message,
        category: {
          id_services_catalog: this.selectedService.categoryId,
          isCouple: this.selectedService.type == 'couple',
          duration: this.selectedDuration,
        },
        origin: 'web',
        payment_app: {
          name: 'conekta',
        },
        promocode: this.promocode ? this.promocode.id : null,
      }
      if (token) {
        data.payment_app.token = token
      } else {
        data.payment_app.id = this.card.id
      }
      if (this.isDelivery) {
        data.physical_certificate = {
          deliveryAddress: `${this.deliveryAddress}, Colonia: ${this.suburb}, Código postal: ${this.postalCode}`,
          id_gift_catalog: this.giftItem.id,
        }
      }
      this.$parse.Cloud.run('create-gift-payment-app', data)
        .then((response) => {
          this.giftCreated = true
          this.isLoading = false
        })
        .catch((error) => {
          console.error(error.message)
          if (error.response) {
            this.error = error.response.data.message.details[0].message
          } else if (error.message) {
            this.error = error.message.details[0].message
          } else {
            this.error = error
          }
          this.giftError = true
          this.isLoading = false
        });
    },
    loadServices() {
      this.$parse.Cloud.run('services-catalog', { device: 'web' })
        .then((data) => {
          data = data.sort((a, b) => (a.order > b.order ? 1 : -1));
          for (let i in data) {
            var category = data[i];
            for (let j in category.types) {
              var type = category.types[j];
              if (type.activeGift) {
                var service = {
                  name:
                    category.name +
                    (type.type == "couple" ? " en " : " ") +
                    type.name,
                  services: type.services,
                  category: category.category,
                  categoryId: category.objectId,
                  type: type.type,
                }
                this.services.push(service)
              }
            }
          }
          if (!this.selectedService) this.selectGift(this.services[0])
        })
        .catch((error) => {
          console.error(error)
        })
    },
    getGiftCatalog() {
      this.$parse.Cloud.run('gifts-catalog', { type: 'single' })
        .then((data) => {
          this.giftCatalog = data
        })
        .catch((error) => {
          console.error(error)
        })
    },
    setCard(value) {
      this.card = value
    },
    setPromo(option) {
      if (option == 'edit') {
        this.promocodeInput = this.promocode.title
        this.promocode = null
      } else {
        this.promocodeInput = null
        this.promocode = null
      }
    },
    cardCreated(card) {
      this.cardModal = false
      this.cardCreatedModal = true
      this.loadCards()
    },
    success() {
      this.clearCardForm()
      this.clearGiftForm()
      this.$router.push({ name: 'gifts' })
    },
  },
  mounted() {
    this.loadServices()
    this.getGiftCatalog()
    if (this.user) {
      this.loadPromos()
      this.loadCards()
      this.giftForm.fromName = this.user.name + " " + this.user.lastname
      this.giftForm.fromEmail = this.user.email
    }
  },
};
</script>

<style lang="scss" scoped>
#purchase-gift-container {
  width: 100%;
  height: 100%;

  #cont-ent {
    & > * {
      padding-top: 3rem;
      padding-bottom: 3rem;

      @media (min-width: 768px) {
        padding-top: 5rem;
        padding-bottom: 5rem;
      }
    }
  }
}

#gift-payment-container {
  width: 100%;
  height: 100%;

  #cont-ent {
    & > * {
      padding-top: 3rem;
      padding-bottom: 3rem;

      @media (min-width: 768px) {
        padding-top: 5rem;
        padding-bottom: 5rem;
      }
    }
  }
}

.time-buttons-container {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    flex-flow: row;

    button:not(:last-child) {
      margin-right: 3rem;
    }
  }

  @media (max-width: 767px) {
    button:not(:last-child) {
      margin-bottom: 1rem;
    }
  }
}
.item-card {
  &.selectable {
    &.selected {
      background: lightgray;
      border: 1px solid #ddd;
    }

    &:hover {
      background: lightgray;
      cursor: pointer;
    }
  }
}
.promo {
  cursor: default;
  color: #00bfa1;
}

.promo_options {
  //transition: color ease-in-out 100ms;
  cursor: default;
  color: #9b9b9b;
  .option {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}

.total_discount {
  text-decoration: line-through;
  font-size: 1.25rem;
}
</style>

<style>
.dd-services {
  width: 100%;
  max-width: 250px;
}
</style>
